import React from 'react';
import classnames from 'classnames';
import { Activity, SearchEntity } from 'v2/models';
import { useStrapiUser } from 'v2/queries';
import { SearchActivityType, useActivityInfo } from 'v2/utils/activityUtils';
import styles from './styles.module.scss';

interface ActivityItemProps {
  activity: Activity;
  userName: string;
  search?: SearchEntity;
}

const RequestActivityItem = ({
  activity,
  search,
  userName,
}: ActivityItemProps) => {
  const getDescription = (isProposalResponse: boolean) => {
    if (isProposalResponse) {
      const dataVendorName =
        activity.relationships.find(
          (rel: any) => rel.table_name === 'DataVendor'
        )?.name || '';
      return `${
        SearchActivityType[activity.type] || activity.type
      } response from ${dataVendorName} for data request ${search?.name}`;
    }
    return `${SearchActivityType[activity.type] || activity.type} this
    request.`;
  };

  const isProposalResponse = ['accepted', 'rejected'].includes(
    SearchActivityType[activity.type]
  );

  return (
    <div>
      <span className={classnames(styles.title)}>{userName}&nbsp;</span>
      <span className={classnames(styles.text)}>
        {getDescription(isProposalResponse)}
      </span>
    </div>
  );
};

const DefaultActivityItem = ({ activity, userName }: ActivityItemProps) => {
  const ActivityInfo = useActivityInfo();

  if (!ActivityInfo[activity.type]) {
    return (
      <div className={classnames(styles.text)}>
        Request activity type not yet implemented
      </div>
    );
  }

  return (
    <div>
      <span className={classnames(styles.text)}>
        {ActivityInfo[activity.type].title} by&nbsp;
      </span>
      <span className={classnames(styles.title)}>{userName}</span>
    </div>
  );
};

type ActivityTitleProps = {
  activity: Activity;
  search: SearchEntity;
};

export function DefaultActivityTitle({ activity, search }: ActivityTitleProps) {
  const { data: userData, isSuccess: userDataIsSuccess } = useStrapiUser({
    id: activity.creator,
  });

  if (!userDataIsSuccess || !userData) {
    return null;
  }

  const isRequestActivity = !!SearchActivityType[activity.type];
  let userName = `${userData.first_name} ${userData.last_name}`;
  if (SearchActivityType[activity.type] === 'responded to') {
    userName =
      activity.relationships.find((rel) => rel.table_name === 'DataVendor')
        ?.name || '';
  } else if (
    SearchActivityType[activity.type] === 'approved' ||
    SearchActivityType[activity.type] === 'reviewed'
  ) {
    const reviewer = search.assigned_to;
    userName = reviewer ? `${reviewer.first_name} ${reviewer.last_name}` : '';
  }

  return isRequestActivity ? (
    <RequestActivityItem
      activity={activity}
      search={search}
      userName={userName}
    />
  ) : (
    <DefaultActivityItem activity={activity} userName={userName} />
  );
}
